module.exports = __webpack_public_path__ + "img/Wp_2065.73da0b8d.png";